import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Handles UX for the "Generate Tags For Assets" modal form
// Provides immediate feedback and closes modal on success.
export default class extends Controller {
  static targets = ["form", "modal", "status"]

  connect() {
    // Attach submit event to intercept Turbo responses
    if (this.hasFormTarget) {
      this.formTarget.addEventListener('turbo:submit-end', (e) => this.handleSubmitEnd(e))
    }
  }

  handleSubmitEnd(event) {
    const { detail: { success } } = event
    if (success) {
      // Close modal
      if (this.hasModalTarget) {
        this.modalTarget.style.display = 'none'
      }
      // Optionally flash a small inline message if still on page (flash via controller already)
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = t('javascript.controllers.asset_tag_generation_controller.generation_complete')
        this.statusTarget.classList.remove('hidden')
        setTimeout(() => this.statusTarget.classList.add('hidden'), 4000)
      }
    } else {
      // Show failure inline (errors appear via flash already)
      if (this.hasStatusTarget) {
        this.statusTarget.textContent = t('javascript.controllers.asset_tag_generation_controller.generation_failed_please_review_inputs')
        this.statusTarget.classList.remove('hidden')
      }
    }
  }
}

